import React from 'react';
import styled from 'styled-components';
import { Body3Regular } from '../../lib/font';
import { colors } from '../../lib/colors';
import { Col, Row } from '../../lib/utils';
import WhiteSquareButton from '../Button/WhiteSquareButton';
import ColorSquareButton from '../Button/ColorSquareButton';

const StyledInput = styled.input`
    width: 64px;
    height: 64px;
    border-radius: 4px;
    border: 1px solid #3d73dd;
    margin-right: 24px;
    font-size: 32px;
    font-weight: 700;
    text-align: center;

    &::placeholder {
        color: ${colors.GREY_300};
        opacity: 0.3;
    }
`;

const ModalAddTrainerBody2 = ({
    onClickNextStep,
    onClickPrevStep,
    digits,
    handleChange,
    handleKeyDown,
    inputRefs,
}: any) => {
    // 하나라도 값이 입력되었는지 확인
    const hasInput = digits.some((digit: string) => digit !== '');

    return (
        <>
            <Col style={{ marginLeft: 48, marginTop: 32 }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>[트레이너 코드]를 입력해주세요!</Body3Regular>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>
                    [트레이너 코드]는 '라포 모바일 - 트레이너 계정'의 'MY 코드번호'를 통해 공유받을 수 있습니다!
                </Body3Regular>
            </Col>
            <Row>
                <Row style={{ width: 400, height: 64, marginTop: 40, marginLeft: 48 }}>
                    {digits.map((digit: any, index: any) => (
                        <StyledInput
                            key={index}
                            ref={inputRefs[index]}
                            type="text"
                            value={digit}
                            onChange={(e) => handleChange(index, e.target.value)}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            maxLength={1}
                            autoFocus={index === 0}
                            placeholder={hasInput ? '' : index === 0 ? 'A' : String(index)}
                        />
                    ))}
                </Row>
            </Row>

            <Row
                style={{
                    width: 312,
                    height: 48,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: 52,
                    marginLeft: 536,
                }}
            >
                <WhiteSquareButton text="이전" size="middle" callBack={onClickPrevStep} />
                <ColorSquareButton text="다음" size="middle" callBack={onClickNextStep} />
            </Row>
        </>
    );
};

export default ModalAddTrainerBody2;
